<!--横向滑动包裹类  -->
<template>
    <div class="SelectTags">
        <CrossSlip crossType="inner" v-if="buttonType=='default'">
        <RButton  v-for="(item,ix) in list" color="tags" :key="`select-tags-it-${ix}`">{{item.name}}</RButton>
            </CrossSlip>
        <div v-if="buttonType=='tour'">
            <RButton  v-for="(item,ix) in list" color="tourTags" :key="`select-tags-it-${ix}`" :font-color="item.fontColor" :bg-color="item.bgColor">{{item.name}}</RButton>
        </div>
    </div>
</template>


<script>

    import RButton from '../Use/r-button'
    import CrossSlip from './cross-slip-wrapper'
    export default {
        name: 'SelectTags',
        components: {RButton,CrossSlip},
        props: {
            list:{
                type:Array,
                default:[]
            },
            buttonType:{
                type:String,
                default:'default'  //default 选择标签  //tour景点标签
            }

        },
        data () {
            return {

            }

        },
        methods: {


        }
    }
</script>
<style lang="less" scoped>
    .SelectTags{


    }

</style>
